import {walletCurrencies} from 'utils/mock';

/**
 * The currencies a collection can be denominated in.
 *
 * `CollectionInput.currency` is the `CurrencyCode` enum, so this is not a free
 * list: anything outside it is rejected as an invalid enum value. It is
 * deliberately narrower than `walletCurrencies`, which carries GBP — a currency
 * the collection input has no member for.
 */
export const COLLECTION_CURRENCY_CODES = [
  'USD',
  'XOF',
  'EUR',
  'XAF',
  'CAD',
  'NGN',
];

/** Codes paired with the names already used elsewhere in the dashboard. */
export const collectionCurrencyOptions = COLLECTION_CURRENCY_CODES.map(code => {
  const known = walletCurrencies.find(entry => entry.key === code);
  return {value: code, label: known?.name ? `${code} — ${known.name}` : code};
});

/**
 * An exchange reports `baseCurrencyCode` as a free-text String, so it can hold
 * something the enum has no member for. Only a value the input will actually
 * accept is worth defaulting to.
 */
export const supportedCurrency = code =>
  COLLECTION_CURRENCY_CODES.includes(code) ? code : undefined;
